<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import axios from 'axios';
import CustomerMainTable from "../../components/datatables/CustomerMainTable.vue";
import { usePermissions } from '@/composables/usePermissions';

export default {
    page: {
        title: "Active Customers",
        meta: [{ name: "description", content: appConfig.description }],
    },

    data() {
        return {
            role:localStorage.getItem('role'),
            title: "Active Customers",
            items: [
                {
                text: "Active Customers",
                href: "/",
                },
            ],
        
            date: '',
            key_search:'',
            program_id:null,
            branchList:null,
            branch_id:null,
            programList:null,
        };
    },
      setup() {
        const {
            canReadCustomersList,
            canUpdateCustomersList,
            canCreateCustomersList,
        } = usePermissions()
        return {
            canReadCustomersList,
            canUpdateCustomersList,
            canCreateCustomersList,
        };
    },
    methods: {

        getPrograms(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'program/raw_data')
            .then(response => {
                if (response) {
                    const list = response.data;
                    this.programList = list.map((programList) => {
                        return {
                            value: programList.id,
                            label: programList.program_name,
                        }
                    });                    
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        getBranches(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'branch/list')
            .then(response => {
                if (response) {
                    const list = response.data;
                    this.branchList = list.map((branchList) => {
                        return {
                            value: branchList.id,
                            label: branchList.name,
                        }
                    });
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },
    },

    components: {
        Layout,
        PageHeader,
        CustomerMainTable,
    },

    mounted() {
        this.getPrograms();
        this.getBranches();
    },
    
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
        <div class="card" v-if="canReadCustomersList">
            <div class="card-header border-bottom-dashed">
                <div class="row g-4 align-items-center">
                    <div class="col-sm">
                        <div>
                            <h5 class="card-title mb-0">Customer List</h5>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <div class="live-preview">
                    <div class="row align-items-center g-12">
                        <div class="col-lg-12">
                            <CustomerMainTable :programList="programList" :branchList="branchList" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="text-center text-muted p-4">
            You do not have permission to view Customers.
     </div>
    </Layout>
</template>